import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useOthersStore } from "../../store/othersStore.js";
import { FloatButton, Popover, message } from "antd";
import Loader from "../loader/loader";
import { CopyToClipboard } from "../../utils/copytoclipboard";

const Uploadfile = () => {
  const { isFileLoading, uploadFile } = useOthersStore();
  const [uploadedURL, setUploadedURL] = useState("");

  const handleFileUpload = (file) => {
    const formData = new FormData();
    formData.append("image", file);

    uploadFile(formData, (res) => {
      if (res.status === 200) {
        setUploadedURL(res.imageUrl);
        document.getElementById("imageUploader").value = "";
      }
    });
  };

  const handleCopy = async () => {
    if (await CopyToClipboard(uploadedURL)) {
      message.success("Copied to clipboard!");
    }
  };

  const content = (
    <div className="flex flex-col gap-2">
      <div>
        Image Uploader (after uploading, copy the link and paste it in featured
        image)
      </div>
      {isFileLoading ? (
        <Loader />
      ) : (
        <div className="flex flex-col gap-3">
          <input
            type="file"
            id="imageUploader"
            accept="image/*"
            onChange={async (e) => {
              const file = e.target.files[0];
              if (file) {
                handleFileUpload(file);
              }
            }}
            className="p-4 text-[18px] font-medium rounded-lg border border-gray-400 cursor-pointer w-max"
          />
          {uploadedURL && (
            <div className="flex items-center gap-3">
              <div className="p-2 border rounded bg-gray-100 text-gray-700">
                <span>Uploaded Image URL: </span>
                <Link
                  to={uploadedURL}
                  target="_blank"
                  className="font-semibold"
                >
                  {uploadedURL}
                </Link>
              </div>
              <button
                onClick={handleCopy}
                className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
              >
                Copy
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      title="Upload image"
      trigger="click"
      placement="topLeft"
    >
      <FloatButton tooltip={<div>Upload file</div>} />
    </Popover>
  );
};

export default Uploadfile;








